import { FusionLayout } from "@/parts/fusion-layout";
import { observer } from "mobx-react";
import { MapView } from "../../agv/parts/map-view";
import { useNavigate } from "react-router";
import { store } from "../../store";
import { useEffect } from "react";

export const PageAgv = observer((): JSX.Element => {
    // Feature flag redirect
    const navigate = useNavigate();

    useEffect(() => {
        if (!store.serviceAgv.enabled) {
            navigate("/");
        }
    }, [navigate]);

    if (!store.serviceAgv.enabled) {
        return <></>;
    }

    return (
        <FusionLayout breadcrumb="AGV" className="relative" fullWidth>
            <MapView />
        </FusionLayout>
    );
});
